import { orderLinesListStyles as styles } from "@insite/content-library/Components/OrderLinesList";
import { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import getColor from "@insite/mobius/utilities/getColor";
import { buttonCommon } from "@solveindustrial/Utilities/styleguide/button";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

const commonItemInfo: SmallHeadingAndTextStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;

            ${mediaQueriesBP.minMD} {
                flex-direction: row;
                justify-content: flex-start;
                gap: 5px;
            }

            @media print {
                display: block;
            }
        `,
    },
    heading: {
        variant: "p",
        weight: 700,
        css: css`
            width: auto;
            margin: 0;
        `,
    },
    text: {
        variant: "p",
        css: css`
            width: auto;
            margin: 0;
        `,
    },
};

const commonOrderLineInfoProtoItem: SmallHeadingAndTextStyles = {
    wrapper: {
        css: css`
            justify-content: space-between;
            height: 100%;
            gap: 4px;
        `,
    },
    heading: {
        variant: "p",
        weight: 700,
        css: css`
            width: auto;
            margin: 0;
        `,
    },
    text: {
        variant: "p",
        weight: 400,
        css: css`
            width: auto;
            text-align: left;
            margin: 0;
        `,
    },
};

styles.gridContainer = {
    ...styles.gridContainer,
    gap: 0,
    offsetCss: css`
        row-gap: 16px;

        .card_container__wrapper {
            border-radius: 4px;
        }
    `,
};

styles.titleGridItem = {
    ...styles.titleGridItem,
    css: css`
        border-bottom: 1px solid ${getColor(colorStrings.commonBorder)};
        padding: 10px 0 15px;
    `,
};

styles.titleText = {
    ...styles.titleText,
    variant: "h3",
    css: css`
        margin: 0;
        padding: 0;
    `,
};

styles.orderLineCardGridContainer = {
    ...styles.orderLineCardGridContainer,
    gap: 0,
    css: css`
        padding: 8px;

        ${mediaQueriesBP.minMD} {
            padding: 16px;
            gap: 16px;
        }
    `,
    offsetCss: css`
        display: flex;
        flex-wrap: nowrap !important;
        gap: 16px;

        ${mediaQueriesBP.minMD} {
            justify-content: space-between;
        }
    `,
};

styles.orderLineCardImageGridItem = {
    ...styles.orderLineCardImageGridItem,
    css: css`
        ${styles.orderLineCardImageGridItem?.css}
        flex-basis: 80px;
        height: 80px;
    `,
};

styles.orderLineCardAddToListGridItem = {
    ...styles.orderLineCardAddToListGridItem,
    css: css`
        ${styles.orderLineCardAddToListGridItem?.css}
        justify-content: flex-end;
    `,
};

styles.productInfoPartNumbersGridContainer = {
    ...styles.productInfoPartNumbersGridContainer,
    gap: 0,
    offsetCss: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
        ${mediaQueriesBP.minMD} {
            justify-content: space-between;
        }
    `,
};

styles.customerProductNumberHeadingAndText = {
    ...styles.customerProductNumberHeadingAndText,
    extendedStyles: {
        ...styles.customerProductNumberHeadingAndText?.extendedStyles,
        ...commonItemInfo,
    },
};

styles.erpNumberHeadingAndText = {
    ...styles.erpNumberHeadingAndText,
    extendedStyles: {
        ...styles.erpNumberHeadingAndText?.extendedStyles,
        ...commonItemInfo,
    },
};
styles.manufacturerHeadingAndText = {
    ...styles.manufacturerHeadingAndText,
    extendedStyles: {
        ...styles.manufacturerHeadingAndText?.extendedStyles,
        ...commonItemInfo,
    },
};
styles.vmiBinNumberHeadingAndText = {
    ...styles.vmiBinNumberHeadingAndText,
    extendedStyles: {
        ...styles.vmiBinNumberHeadingAndText?.extendedStyles,
        ...commonItemInfo,
    },
};

styles.productInfoCustomerProductGridItem = {
    ...styles.productInfoCustomerProductGridItem,
    width: 12,
};

styles.productInfoErpNumberGridItem = {
    ...styles.productInfoErpNumberGridItem,
    width: 12,
};

styles.productInfoManufacturerItemGridItem = {
    ...styles.productInfoManufacturerItemGridItem,
    width: 12,
};

styles.productInfoVmiBinNumberGridItem = {
    ...styles.productInfoVmiBinNumberGridItem,
    width: 12,
};

styles.priceHeadingAndText = {
    ...styles.priceHeadingAndText,
    extendedStyles: {
        ...styles.priceHeadingAndText?.extendedStyles,
        ...commonOrderLineInfoProtoItem,
    },
};

styles.productInfoQtyOrderedHeadingAndText = {
    ...styles.productInfoQtyOrderedHeadingAndText,
    extendedStyles: {
        ...styles.productInfoQtyOrderedHeadingAndText?.extendedStyles,
        ...commonOrderLineInfoProtoItem,
    },
};

styles.productInfoQtyShippedHeadingAndText = {
    ...styles.productInfoQtyShippedHeadingAndText,
    extendedStyles: {
        ...styles.productInfoQtyShippedHeadingAndText?.extendedStyles,
        ...commonOrderLineInfoProtoItem,
    },
};

styles.subtotalWithoutVatHeadingAndText = {
    ...styles.subtotalWithoutVatHeadingAndText,
    extendedStyles: {
        ...styles.subtotalWithoutVatHeadingAndText?.extendedStyles,
        ...commonOrderLineInfoProtoItem,
    },
};

styles.productInfoSubtotalHeadingAndText = {
    ...styles.productInfoSubtotalHeadingAndText,
    ...commonOrderLineInfoProtoItem,

    extendedStyles: {
        ...styles.productInfoSubtotalHeadingAndText?.extendedStyles,
        ...commonOrderLineInfoProtoItem,
    },
};

styles.productInfoQtyOrderedGridItem = {
    ...styles.productInfoQtyOrderedGridItem,
    width: [6, 6, 4, 4, 4],
};

styles.productInfoQtyShippedGridItem = {
    ...styles.productInfoQtyShippedGridItem,
    width: [6, 6, 4, 4, 4],
};

styles.productInfoSubtotalGridItem = {
    ...styles.productInfoSubtotalGridItem,
    width: [12, 12, 4, 4, 4],
};
